import { usePrefersReducedMotion } from "@circleco/compass/hooks/usePrefersReducedMotion";
import { useLayoutEffect, useState } from "react";

import type { ConversationPanelState } from "../types";
import { useAnimTick } from "./useAnimTick";

export const useFullscreenTransitionMask = (
  conversationPanelState: ConversationPanelState,
) => {
  const { isAnimating, previousValue, endAnimation } = useAnimTick(
    conversationPanelState,
  );
  const [isRevealing, setIsRevealing] = useState(false);
  const shouldReduceMotion = usePrefersReducedMotion();
  const isFullscreen = conversationPanelState === "fullscreen";
  const isFullscreenTransition =
    isAnimating && (isFullscreen || previousValue === "fullscreen");
  const isTransitionMaskOpaque = isFullscreenTransition && !shouldReduceMotion;

  useLayoutEffect(() => {
    if (isTransitionMaskOpaque && isRevealing) {
      setIsRevealing(false);
    }
  }, [isRevealing, isTransitionMaskOpaque]);

  const completeGeometryTransition = () => {
    const shouldReveal =
      previousValue === "fullscreen" && !isFullscreen && !shouldReduceMotion;

    endAnimation();
    if (shouldReveal) {
      setIsRevealing(true);
    }
  };

  return {
    isAnimating,
    isGeometryAnimating: isAnimating && !shouldReduceMotion,
    isRevealing,
    isTransitionMaskOpaque,
    completeGeometryTransition,
    completeMaskReveal: () => setIsRevealing(false),
  };
};
